// libs
import React, { memo } from 'react';
import cx from 'classnames';
import { shallow } from 'zustand/shallow';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
//stores
import useWriteCampaignStore from '@/stores/WriteCampaign';
import useReadCampaignStore from '@/stores/ReadCampaign';
// hooks
import useNudge from '@/hooks/useNudge';
// components
import SelectedProducts from '@/components/SelectedProducts';
// widgets
import Tile from '@/widgets/Tile/Tile';
import Nudge from '@/pages/instamart/campaign/create/widgets/Nudge';
// consants
import { CampaignWriteModeEnum } from '@/stores/WriteCampaign/constants';
import { Phrases } from '@/pages/instamart/campaign/create/widgets/Nudge/constants';
import ProductSearch from '@/components/ProductSearch/ProductSearch';
// styles
import style from './Products.module.scss';
function Products({ mode, currentCampaign }) {
    const { selectedAdGroupCandidates, setAdGroupCandidates, validationMessages, isValid, } = useWriteCampaignStore((store) => ({
        selectedAdGroupCandidates: store.adGroups[0].candidates,
        setAdGroupCandidates: store.setAdGroupCandidates,
        validationMessages: store.validationMessages,
        isValid: store.isValid,
    }), shallow);
    const { isProductNudgeVisible } = useNudge();
    const { campaign: readCampaign } = useReadCampaignStore();
    const handleAdGroupCandidatesUpdate = (candidates) => {
        const updatedCandidates = assignCandidatesMetric(candidates);
        setAdGroupCandidates(updatedCandidates);
        isValid(['candidates']);
    };
    const preSelectedProducts = mode === CampaignWriteModeEnum.EDIT && currentCampaign
        ? currentCampaign.adGroups[0].candidates
        : [];
    const onDelete = (id) => {
        const newSelectedOptions = selectedAdGroupCandidates.filter((option) => option.id !== id);
        handleAdGroupCandidatesUpdate(newSelectedOptions);
    };
    const assignCandidatesMetric = (candidates) => {
        if (mode === CampaignWriteModeEnum.EDIT && readCampaign) {
            const updatedCandidates = candidates.map((candidate) => {
                var _a;
                const matchingCandidate = (_a = readCampaign.adGroups[0]) === null || _a === void 0 ? void 0 : _a.candidates.find((campaignCandidate) => campaignCandidate.id === candidate.id);
                if (matchingCandidate) {
                    const metrics = matchingCandidate.metrics;
                    return Object.assign(Object.assign({}, candidate), { metrics: metrics });
                }
                return candidate;
            });
            return updatedCandidates;
        }
        return candidates;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Tile, { className: style.tile },
            React.createElement("div", { className: style.container },
                React.createElement("div", { className: cx(style.description) },
                    React.createElement(Text, { variant: 'header_H5_Bold', color: 'text_Highest_Emphasis' }, "Choose Product(s) for your Ad"),
                    React.createElement(Text, { className: style.descriptionText, variant: 'body_B1_Reg', color: 'text_Med_Emphasis' }, "Choose the list of products for which you want to run ad on")),
                React.createElement("div", { className: style.containerSearch },
                    isProductNudgeVisible && (React.createElement(Nudge, { text: Phrases.MIN_PRODUCTS })),
                    React.createElement(ProductSearch, { className: style.productSearch, selectedAdGroupCandidates: selectedAdGroupCandidates, setAdGroupCandidates: handleAdGroupCandidatesUpdate, validationMessages: validationMessages })))),
        selectedAdGroupCandidates.length > 0 && (React.createElement(Tile, { className: style.tileSelectedProducts },
            React.createElement("div", { className: style.containerSelectedProducts },
                React.createElement(SelectedProducts, { mode: mode, onDelete: onDelete, selectedOptions: selectedAdGroupCandidates, preSelectedProducts: preSelectedProducts }))))));
}
export default memo(Products);
